/** Stored as an article's imageUrl when the author removed the generated cover. */
export const HIDDEN_ARTICLE_COVER = ""

export const isArticleCoverHidden = (imageUrl: string | null | undefined) =>
	imageUrl === HIDDEN_ARTICLE_COVER

/** A translation without its own cover follows the article's, removal included. */
export const ownArticleCover = (
	translationImageUrl: string | null | undefined,
	articleImageUrl: string | null | undefined,
) => translationImageUrl ?? articleImageUrl ?? null
